import { getErrorDetail } from "components/utility/utils";
import { fetchOrchidAPI } from "utils/api";

export default async function setIntakeForms(
  forms: number[],
  onBehalfOf?: string,
) {
  const res = await fetchOrchidAPI(
    `/api/notes/v1/forms/intake/${
      onBehalfOf ? `?on_behalf_of=${onBehalfOf}` : ""
    }`,
    {
      method: "PUT",
      body: JSON.stringify({
        general_intake_forms: forms,
      }),
    },
  );

  if (!res.ok) {
    const responseText = await res.text();
    throw new Error(getErrorDetail(responseText));
  }

  return res.json();
}
